import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductMockup } from './ProductMockup';
export function Solution() {
  return <section className="bg-brand-cream py-24 px-6 overflow-hidden" data-id="element-65">
      <div className="max-w-6xl mx-auto" data-id="element-66">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-67">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-68">
            <h2 className="text-[2rem] md:text-[2.4rem] text-brand-darkgreen mb-8 leading-tight" data-id="element-69">
              Esta guía tiene todo lo que necesitás para empezar hoy
            </h2>

            <div className="space-y-6 text-brand-gray text-lg mb-10" data-id="element-70">
              <p data-id="element-71">
                Olvidate de las dudas y los miedos. Hemos recopilado años de
                investigación y experiencia práctica en un sistema paso a paso
                que cualquiera puede seguir desde su cocina.
              </p>
              <p data-id="element-72">
                Aprenderás a formular platos balanceados, hacer transiciones
                seguras y verás cómo la salud, el pelaje y la energía de tu
                mascota mejoran en cuestión de semanas.
              </p>
            </div>

            <CTAButton onClick={() => document.getElementById('incluye')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-73">
              Ver qué incluye →
            </CTAButton>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center lg:justify-end" data-id="element-74">
            <ProductMockup maxWidth="max-w-[300px]" data-id="element-75" />
          </motion.div>
        </div>
      </div>
    </section>;
}